import { useAxios } from './useAxios'

export interface IVideoCall {
    id: number
    name: string
    source: string
    duration: number
    durationUnit: string
    schedulingRange: number
    schedulingInterval: number
    schedulingIntervalUnit: string
    message?: string
    label?: string
    createdAt: Date
    updatedAt: Date
}

export const useVideoCall = () => {
    const { get, post, patch, delete: del } = useAxios()

    const createVideoCall = async (botId: number, data: any) => {
        const formData = new FormData()
        Object.keys(data).forEach(key => {
            if (data[key] !== undefined && data[key] !== null) {
                formData.append(key, data[key])
            }
        })

        const response = await post(`/bots/${botId}/video-calls`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data
    }

    const updateVideoCall = async (id: number, data: any) => {
        const formData = new FormData()
        Object.keys(data).forEach(key => {
            if (data[key] !== undefined && data[key] !== null) {
                formData.append(key, data[key])
            }
        })

        const response = await patch(`/video-calls/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data
    }

    const deleteVideoCall = async (id: number) => {
        const response = await del(`/video-calls/${id}`)
        return response.data
    }

    const fetchVideoCall = async (id: string | number, botUuid?: string, nodeId?: string, telegramUserId?: string): Promise<IVideoCall> => {
        const response = await get(`/video-calls/${id}`, {
            params: { botUuid, nodeId, telegramUserId }
        })
        return response.data
    }

    const fetchBotVideoCalls = async (botId: number): Promise<IVideoCall[]> => {
        const response = await get(`/bots/${botId}/video-calls`)
        return response.data
    }
    const finishVideoCall = async (botUuid: string, nodeId: string, telegramUserId: string) => {
        const response = await post('/video-calls/finish', { botUuid, nodeId, telegramUserId })
        return response.data
    }

    return {
        createVideoCall,
        updateVideoCall,
        deleteVideoCall,
        fetchVideoCall,
        fetchBotVideoCalls,
        finishVideoCall
    }
}
